import { createContext, useContext, useEffect, useState } from "react";
import { auth, loginUser, registerUser, fetchMe } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest, object = logged in

  useEffect(() => {
    (async () => {
      if (!auth.getToken()) { setUser(false); return; }
      try {
        const u = await fetchMe();
        setUser(u);
      } catch (e) {
        auth.clear();
        setUser(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const d = await loginUser({ email, password });
    auth.setToken(d.token);
    setUser(d.user);
    return d;
  };

  const register = async (payload) => {
    const d = await registerUser(payload);
    auth.setToken(d.token);
    setUser(d.user);
    return d;
  };

  const logout = () => { auth.clear(); setUser(false); };

  return <AuthCtx.Provider value={{ user, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
